import { ca } from '@cian/analytics';

export const trackAutoOpenDatesModal = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'DailyrentCalendar',
    label: 'Popup',
  });
};
